import { Chip } from '@mui/material'
import { DateTime } from 'luxon'
import PropTypes from 'prop-types'

export function SuspensionStatusChip({ isSuspended, liftedAt }) {
    if (!isSuspended) {
        return <Chip label="Active" size="small" color="success" variant="outlined" />
    }

    if (liftedAt) {
        const label = `Suspended until ${DateTime.fromISO(liftedAt).toLocaleString(DateTime.DATE_MED)}`
        return <Chip label={label} size="small" color="warning" />
    }

    return <Chip label="Permanently Suspended" size="small" color="error" />
}

SuspensionStatusChip.propTypes = {
    isSuspended: PropTypes.bool,
    liftedAt: PropTypes.string
}
